<div class="flex">
  <sbnb-subnav [header]="'OPERATIONS.OPERATIONS' | transloco">
    <sbnb-operations-subnav></sbnb-operations-subnav>
    <sbnb-helptext-wrapper [area]="'sidebar'" [pageId]="'my-business-profit-and-loss'"></sbnb-helptext-wrapper>
  </sbnb-subnav>

  <main class="subnav__exists flex-1" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <div class="w-full relative">
      <app-feature-flag-tabs>
        <sbnb-page-header navTabs>
          <div class="flex">
            <h2>Profit and Loss</h2>
          </div>
        </sbnb-page-header>
        <div class="flex">
          <h2>Profit and Loss Report</h2>
        </div>
      </app-feature-flag-tabs>

      <!-- Filters -->
      <div class="py-4" *ngIf="filtersLoadingState$ | async as filtersLoadingState">
        <hospitable-filters
          *ngIf="filtersLoadingState === LoadingState.Success"
          [filters]="filters$ | async"
          [appliedFilters]="appliedFilters$ | async"
          (applyFilter)="onApplyFilter($event)"
          (addFilter)="onAddFilter($event)"
          (removeFilter)="onRemoveFilter($event)"></hospitable-filters>

        <sbnb-loading-spinner *ngIf="filtersLoadingState === LoadingState.Pending"></sbnb-loading-spinner>
      </div>

      @if (pnl$ | async; as pnl) {
        @if (!pnl.data) {
          <div class="max-w-5xl mx-auto p-6">
            <sbnb-no-items
              icon="company"
              text="No data available"
              subtext="You might need to set up your business."></sbnb-no-items>
          </div>
        } @else {
          <div class="py-6">
            <div class="flex flex-col gap-4">
              <!-- Account Header -->
              <div class="flex items-center py-2 border-b border-smoke-light">
                <h3 class="flex-1">Account</h3>
                <h3 class="text-right">Total</h3>
              </div>

              <!-- Income -->
              @if (pnl.data.income) {
                <sbnb-collapsible-card [defaultOpen]="true" headerCaretPosition="before" headerClass="bg-smoke-lighter">
                  <div title class="flex items-center py-2">
                    <h4 class="flex-1">Income</h4>
                  </div>

                  <ng-template sbnbCollapsibleCardContent>
                    <div class="flex flex-col gap-2 mt-2">
                      @for (item of pnl.data.income.records; track item.title) {
                        <div class="flex items-center ml-8 text-night">
                          <span class="flex-1">{{ item.title }}</span>
                          <span class="text-right font-mono">{{ item.formatted_total }}</span>
                        </div>
                        @for (subItem of item.records; track subItem.title) {
                          <div class="flex items-center ml-16 text-night">
                            <span class="flex-1">{{ subItem.title }}</span>
                            <span class="text-right font-mono">{{ subItem.formatted_total }}</span>
                          </div>
                        }
                      }
                      <mat-divider></mat-divider>
                      <div class="flex justify-between ml-8">
                        <strong>Total for Income</strong>
                        <strong class="text-right font-mono">{{ pnl.data.income.formatted_total }}</strong>
                      </div>
                    </div>
                  </ng-template>
                </sbnb-collapsible-card>
              }

              <!-- Cost of Goods Sold -->
              @if (pnl.data.cost_of_goods_sold) {
                <sbnb-collapsible-card
                  [defaultOpen]="true"
                  headerCaretPosition="before"
                  [showDivider]="false"
                  headerClass="bg-smoke-lighter">
                  <div title class="flex items-center py-2">
                    <h4 class="flex-1">Cost of Goods Sold</h4>
                  </div>

                  <ng-template sbnbCollapsibleCardContent>
                    <div class="flex flex-col gap-2 mt-2">
                      @for (item of pnl.data.cost_of_goods_sold.records; track item.title) {
                        <div class="flex items-center ml-8 text-night">
                          <span class="flex-1">{{ item.title }}</span>
                          <span class="text-right font-mono">{{ item.formatted_total }}</span>
                        </div>
                        @for (subItem of item.records; track subItem.title) {
                          <div class="flex items-center ml-16 text-night">
                            <span class="flex-1">{{ subItem.title }}</span>
                            <span class="text-right font-mono">{{ subItem.formatted_total }}</span>
                          </div>
                        }
                      }
                      <mat-divider></mat-divider>
                      <div class="flex justify-between ml-8">
                        <strong>Total for Cost of Goods Sold</strong>
                        <strong class="text-right font-mono">
                          {{ pnl.data.cost_of_goods_sold.formatted_total }}
                        </strong>
                      </div>
                    </div>
                  </ng-template>
                </sbnb-collapsible-card>
              }

              <!-- Gross Profit -->
              @if (pnl.data.gross_profit) {
                <div class="flex items-center p-2 bg-smoke-lighter border-t border-smoke">
                  <h4 class="flex-1">Gross Profit</h4>
                  <h4 class="text-right font-mono">{{ pnl.data.gross_profit.formatted_total }}</h4>
                </div>
              }

              <!-- Expenses -->
              @if (pnl.data.expenses) {
                <sbnb-collapsible-card
                  [defaultOpen]="true"
                  headerCaretPosition="before"
                  [showDivider]="false"
                  headerClass="bg-smoke-lighter">
                  <div title class="flex items-center py-2">
                    <h4 class="flex-1">Expenses</h4>
                    <h4 class="text-right font-mono">{{ pnl.data.expenses.formatted_total }}</h4>
                  </div>

                  <ng-template sbnbCollapsibleCardContent>
                    <div class="flex flex-col gap-2 mt-2">
                      @for (item of pnl.data.expenses.records; track item.title) {
                        <div class="flex items-center ml-8 text-night">
                          <span class="flex-1">{{ item.title }}</span>
                          <span class="text-right font-mono">{{ item.formatted_total }}</span>
                        </div>
                        @for (subItem of item.records; track subItem.title) {
                          <div class="flex items-center ml-16 text-night">
                            <span class="flex-1">{{ subItem.title }}</span>
                            <span class="text-right font-mono">{{ subItem.formatted_total }}</span>
                          </div>
                        }
                      }
                      <mat-divider></mat-divider>
                      <div class="flex justify-between ml-8">
                        <strong>Total for Expenses</strong>
                        <strong class="text-right font-mono">{{ pnl.data.expenses.formatted_total }}</strong>
                      </div>
                    </div>
                  </ng-template>
                </sbnb-collapsible-card>
              }

              <!-- Net Operating Income -->
              @if (pnl.data.operating_income) {
                <div class="flex items-center p-2 bg-smoke-lighter border-t border-smoke">
                  <h4 class="flex-1">Net Operating Income</h4>
                  <h4 class="text-right font-mono">{{ pnl.data.operating_income.formatted_total }}</h4>
                </div>
              }
            </div>
          </div>
        }
      }
    </div>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Operations'">
  <sbnb-operations-subnav></sbnb-operations-subnav>
</sbnb-mobile-sidebar>
